import { z } from 'zod';

import { DocumentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateDocumentTitleEvent = BaseLoanEvent.extend({
  type: z.literal('updateDocumentTitle'),
  documentId: DocumentId,
  originalTitle: z.string(),
  newTitle: z.string(),
});

export type UpdateDocumentTitleEvent = z.infer<typeof UpdateDocumentTitleEvent>;
